import { useT } from '@/i18n';
import { BrandLockup } from '@/components/BrandLockup';

/** The ORCA splash inside the app (same markup and styles as the first-frame
 *  splash in index.html): shown while the session or an incoming link is
 *  being checked, so every wait looks like one and the same brand moment. */
export function BrandPreloader({ text }: { text?: string }) {
  const { t } = useT('auth');
  return (
    <div className="orca-pl" role="status" aria-live="polite">
      <div className="orca-pl-glow" aria-hidden="true" />
      <div className="orca-pl-content">
        <BrandLockup className="orca-pl-logo" />
        <p className="orca-pl-text">{text ?? t('preloader')}</p>
      </div>
    </div>
  );
}
